var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('html-page',{attrs:{"api":"https://api.prohealthfactor.ru/api/v1/htm/lkb/service/data/page"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }